import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { PurchasePayload, PurchaseResource } from "../types";

type PurchaseUpdatePayload = PurchasePayload & {
  id: string;
};

const updatePurchase = async (payload: PurchaseUpdatePayload) => {
  const response = (await stellar.action("editPurchase", payload)) as {
    purchase?: PurchaseResource;
  };

  return response.purchase ?? (payload as PurchaseResource);
};

export const useUpdatePurchaseMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["purchases"] });
    },
  });
};
